import { useEffect, useState } from "react";
import styles from "./MinhaContaPedido.module.css";
import { useTranslation } from "react-i18next";
import api from "../../utils/axios/api";
import ModalConfirmarRetirada from "../ModalConfirmarRetirada/ModalConfirmarRetirada";
import ProdutoItem from "../Carrinho/Itens";
import i18n from "../../i18n";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useChat } from "../../hooks/useChat";
import Chat from "../Chat/Chat";

function MinhaContaPedido() {
  const { t } = useTranslation();
  const [pedidos, setPedidos] = useState<any[]>([]);
  const [showProductList, setShowProductList] = useState<boolean[]>([]);
  const [showModalConfirmPickup, setShowModalConfirmPickup] = useState(false);
  const [orderToConfirmPickup, setOrderToConfirmPickup] = useState<any | null>(
    null
  );
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");

  const { socket, showChat, entrepreneurUser, store, openChat, closeChat } =
    useChat({
      chatType: "ORDER",
      productOrOrderId: selectedOrderId ?? undefined,
      clientId,
    });

  const handleOpenChat = (orderId: string) => {
    setSelectedOrderId(orderId);
    openChat(orderId);
  };

  useEffect(() => {
    const fetchClientProducts = async () => {
      try {
        const response = await api.get(`/order/client/${clientId}`);
        setPedidos(response.data);
        setShowProductList(
          Array.from({ length: response.data.length }, () => false)
        );
      } catch (error) {
        console.error("Erro ao buscar pedidos:", error);
      }
    };

    fetchClientProducts();
  }, [clientId]);

  const currencyLocalFormat = (value: number) => {
    return value.toLocaleString(i18n.language || "pt-BR", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  const handleToggleShowProducts = (index: number) => {
    setShowProductList((prev) =>
      prev.map((val, i) => (i === index ? !val : val))
    );
  };

  const handleConfirmPickup = () => {
    console.log("Pedido confirmado:", orderToConfirmPickup);
    setShowModalConfirmPickup(false);
  };

  async function handleConfirmReceipt(orderId: string, index: number) {
    try {
      await api.patch(`/order/status/${orderId}`);
      setPedidos((prevValue) => {
        if (index < 0 || index >= prevValue.length) return prevValue;
        const aux = [...prevValue];
        aux[index].status = "RECEIVED";
        return aux;
      });
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className={styles.mainContainer}>
      <h1>{t(`accountMenu.orders`)}</h1>
      <div className={styles.container}>
        {pedidos.map((order, index) => (
          <div key={order.id} className={styles.orderContainer}>
            <h2>{t(`accountMenu.orderData`)}</h2>
            <div className={styles.orderInfoContainer}>
              <div>
                <h3>
                  {t(`accountMenu.order`)} #{order.id}
                </h3>
                <p>
                  <strong>{t("pedidos.nome")}</strong> {order.store.name}
                </p>
                <p>
                  <strong>{t("pedidos.dataCompra")}</strong>{" "}
                  {new Date(order.createdAt).toLocaleDateString()}
                </p>
                <p>
                  <strong>{t("pedidos.dataEntrega")}</strong>{" "}
                  {new Date(order.date).toLocaleDateString()}
                </p>
                <p>
                  <strong>{t("pedidos.formaPagamento")} </strong>
                  {order.paymentMethod === 'credit_card' ? "Cartão de crédito" : 'Pix'}
                </p>
                <p>
                  <strong>{t("pedidos.statusPagamento")} </strong>
                  {order.status === "PAYED"
                    ? t("accountMenu.paid")
                    : order.status === "PAYMENT_PENDING"
                    ? t("accountMenu.pendent")
                    : order.status === "CANCELED"
                    ? t("accountMenu.cancelled")
                    : undefined}
                </p>
                <p>
                  <strong>{t(`accountMenu.address`)}:</strong>
                  {order.address && (
                    <span className={styles.addressInfoContainer}>
                      <span>{order.address.name}</span>
                      <span>
                        {order.address.street}, {order.address.number}{" "}
                        {order.address.district}
                      </span>
                      {order.address.complement && (
                        <span>{order.address.complement}</span>
                      )}
                      <span>
                        {order.address.city}, {order.address.state}{" "}
                        {order.zipCode}
                      </span>
                    </span>
                  )}
                </p>
                <p>
                  <strong>{t(`accountMenu.type`)}: </strong>
                  {order.typeDelivery === "DELIVERY"
                    ? t("accountMenu.delivery")
                    : t("accountMenu.pickup")}
                </p>
                <p>
                  <strong>{t("pedidos.total")}:</strong> R$
                  {currencyLocalFormat(order.price)}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  gap: "24px 0",
                  alignItems: "stretch",
                  padding: "0 16px",
                  justifyContent: "center",
                }}
              >
                <button className={styles.invoiceButton}>
                  {t("pedidos.notaFiscal")}
                </button>
                <button
                  className={styles.invoiceButton}
                  onClick={() => navigate(`/client/order/${order.id}`)}
                >
                  {t("pedidos.acompanharPedido")}
                </button>
                {order.status === "RECEIVED" ? (
                  <p>Produto Entregue</p>
                ) : order.status !== "PAYMENT_PENDING" ? (
                  <button
                    className={styles.invoiceButton}
                    onClick={() => handleConfirmReceipt(order.id, index)}
                  >
                    {t("pedidos.confirmarRecebimento")}
                  </button>
                ) : undefined}
                <button
                  className={styles.invoiceButton}
                  onClick={() => handleOpenChat(order.id)}
                >
                  {t("pedidos.relatarProblema")}
                </button>
              </div>
            </div>
            <button
              className={styles.showProductList}
              onClick={() => handleToggleShowProducts(index)}
            >
              {showProductList[index] ? (
                <MdExpandLess size={45} />
              ) : (
                <MdExpandMore size={45} />
              )}
            </button>
            {showProductList[index] && (
              <div className={styles.productsOuterContainer}>
                <h2>{t(`accountMenu.orderProducts`)}</h2>
                <div className={styles.productsInnerContainer}>
                  {order.product_order.map((productOrder: any) => (
                    <ProdutoItem
                      key={productOrder.id}
                      entrepreneurView
                      produto={productOrder.product}
                      onRemove={() => {}}
                      amount={productOrder.amount}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
        <ModalConfirmarRetirada
          isOpen={showModalConfirmPickup}
          handleCancel={() => setShowModalConfirmPickup(false)}
          handleYes={handleConfirmPickup}
          order={orderToConfirmPickup ?? null}
        />
      </div>

      {showChat && socket && entrepreneurUser && selectedOrderId && (
        <Chat
          socket={socket}
          type="ORDER"
          id={selectedOrderId}
          onClose={closeChat}
          infos={{
            otherUserId: entrepreneurUser.id,
            userName: store?.name ?? null,
          }}
        />
      )}
    </div>
  );
}

export default MinhaContaPedido;
